import { hexBadgeStyle } from '../../../common/utils/badge-color.js'
import './portal-absence-badge.css'

export interface PortalAbsenceBadgeProps {
    /**
     * `portal_leave_types.badge_type` — either a canonical leave-type category
     * (see `common/types/portal-leave-types.ts`, drives the CSS class) or
     * a literal `#RRGGBB` hex string for admin-defined custom colors.
     * An unrecognized class value still renders with the neutral base style.
     */
    badgeType: string
    /** Display text — the leave type's name. */
    label: string
}

export const PortalAbsenceBadge = ({ badgeType, label }: PortalAbsenceBadgeProps) => {
    const inlineStyle = hexBadgeStyle(badgeType)
    if (inlineStyle) {
        return (
            <span className="portal-absence-badge" style={inlineStyle}>
                {label}
            </span>
        )
    }
    return (
        <span className={`portal-absence-badge portal-absence-badge--${badgeType}`}>{label}</span>
    )
}
